// IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F)
// Оформление уровней дерева REPORT2 (AttrGrid, childItemsPath) — варианты из прототипа tree_levels_proto.html как опции, чтобы выбрать на живой базе.
// Дефолт — как сейчас (now: плашка раскрытой группы fe.ux.groupRowPill). Здесь — только чистые расчёты: разбор опций, структура видимых строк
// (родитель, последний потомок, есть ли следующий брат, корень оформленного поддерева) и слои фона ячейки / маски отступа под режим.
// Рисует AttrGrid.treeLevel_after (пост-шаг formatItem_fast: полный и кэш-путь) — фоном (background-image) ячейки и существующей маски отступа
// (cell-delivery-left-0, дерево сдвигает ячейку на уровень × 12 px), классами — фокус и подсветка поддерева. Новых DOM-узлов нет, ширина ячеек не меняется.
//   guides (A) — линии-направляющие отступа с «локтем» к ребёнку, ветка текущей строки темнее; без заливки;
//   depth  (B) — ровная заливка поддерева по глубине на всю ширину (темнее у раскрытого родителя, светлее к листьям), без радиуса;
//   rail   (C) — цветная полоса раздела слева (цвет — по подписи корня поддерева, по порядку появления), тоньше на каждый раскрытый уровень;
//   card   (E) — раскрытое поддерево — «карточка» на всю ширину: рамка 1 px, радиус 4 px, низ темнее, шапка с лёгким тоном;
//   focus  (F) — всё вне поддерева текущей группы приглушено (Esc снимает до следующего выбора).
// Отдельно fe.ux.treeSubtreeHover (из D) — наведение на раскрытую группу подсвечивает её поддерево; по умолчанию ВЫКЛ.

export const TREE_LEVEL_STYLE_FLAG = 'fe.ux.treeLevelStyle'
export const TREE_SUBTREE_HOVER_FLAG = 'fe.ux.treeSubtreeHover'
export const TREE_LEVEL_STYLES = ['now', 'guides', 'depth', 'rail', 'card', 'focus']
export const TREE_INDENT = 12   // сдвиг ячейки дерева на уровень (AttrGrid formatItem_cells: breakCollapseWidth)
export const TREE_CARD_R = 4
export const TREE_RAIL_COLORS = 6
export const TLS_CLASSES = ['tls-dim', 'tls-froot', 'tls-sub', 'tls-subh']

// Значение опции режима: неизвестное / пустое — now (как сейчас)
export function treeLevelStyle_mode(v) {
    const s = typeof v === 'string' ? v.trim().toLowerCase() : ''
    return TREE_LEVEL_STYLES.includes(s) ? s : 'now'
}

// bool-опция: true / 'true' / 1 / '1' / 'on' — вкл; остальное — выкл (дефолт ВЫКЛ)
export function treeSubtreeHover_on(v) {
    if (v === true || v === 1) return true
    const s = typeof v === 'string' ? v.trim().toLowerCase() : ''
    return s === 'true' || s === '1' || s === 'on' || s === 'yes'
}

// Опции грида: overrides (из события fe-display-option) главнее настроек store
export function treeLevelStyle_read(store, overrides) {
    const ov = overrides || {}
    const get = (k, d) => {
        if (Object.prototype.hasOwnProperty.call(ov, k)) return ov[k]
        try { return store?.setting?.(k, d) } catch (e) { return d }
    }
    return { mode: treeLevelStyle_mode(get(TREE_LEVEL_STYLE_FLAG, 'now')), hover: treeSubtreeHover_on(get(TREE_SUBTREE_HOVER_FLAG, false)) }
}

// Структура видимых строк: get(i) → { level, visible, open, styled } (level — уровень строки дерева, не целое — граница: строк-предков нет;
// open — раскрытая группа с детьми; styled — раскрытая группа с оформлением уровня, без «Plain level»). Скрытые строки — parent -1, не участвуют.
// parent — ближайшая предыдущая видимая строка уровнем меньше; lastDesc — последний видимый потомок (у листа — сама строка);
// hasNext — после строки есть видимый брат того же уровня до выхода к предку; root — внешний оформленный раскрытый предок-или-сама (-1 — нет).
export function treeLevels_build(n, get) {
    n = Math.max(0, n | 0)
    const T = {
        n,
        level: new Int16Array(n), vis: new Uint8Array(n), open: new Uint8Array(n), styled: new Uint8Array(n),
        parent: new Int32Array(n).fill(-1), lastDesc: new Int32Array(n).fill(-1), hasNext: new Uint8Array(n), root: new Int32Array(n).fill(-1),
    }
    const stack = []
    let prev = -1
    for (let i = 0; i < n; i++) {
        const r = get(i) || {}
        if (r.visible === false) continue
        const lv = Number.isInteger(r.level) && r.level >= 0 ? r.level : -1
        T.vis[i] = 1; T.level[i] = lv
        T.open[i] = r.open ? 1 : 0
        T.styled[i] = r.open && r.styled ? 1 : 0
        while (stack.length && T.level[stack[stack.length - 1]] >= lv) {
            const t = stack.pop()
            T.lastDesc[t] = prev
            if (lv >= 0 && T.level[t] === lv) T.hasNext[t] = 1
        }
        const p = lv >= 0 && stack.length ? stack[stack.length - 1] : -1
        T.parent[i] = p
        T.root[i] = p >= 0 && T.root[p] >= 0 ? T.root[p] : (T.styled[i] ? i : -1)
        stack.push(i)
        prev = i
    }
    while (stack.length) T.lastDesc[stack.pop()] = prev
    return T
}

// Предки строки — от внешнего к ближайшему
export function treeLevels_ancestors(T, i) {
    const out = []
    if (!T || i < 0 || i >= T.n) return out
    for (let p = T.parent[i]; p >= 0; p = T.parent[p]) out.unshift(p)
    return out
}

// Группа строки sel: раскрытая группа — она сама, иначе её родитель (-1 — нет). Ветка «текущей строки» (guides) и корень фокуса (focus)
export function treeLevels_groupOf(T, sel) {
    if (!T || !Number.isInteger(sel) || sel < 0 || sel >= T.n || !T.vis[sel]) return -1
    return T.open[sel] ? sel : T.parent[sel]
}

export function treeLevels_inSubtree(T, root, i) {
    return !!T && root >= 0 && root < T.n && i >= root && i <= T.lastDesc[root]
}

// Тон заливки depth: 1 — у корня оформленного поддерева (темнее), глубже — светлее, до 3; 0 — строка вне оформленного поддерева
export function treeLevels_depthTone(T, i) {
    if (!T || i < 0 || i >= T.n || !T.vis[i]) return 0
    const r = T.root[i]
    if (r < 0) return 0
    return Math.min(3, 1 + Math.max(0, T.level[i] - T.level[r]))
}

// Цвета полос разделов: подписи корней в порядке строк → номер цвета по первому появлению подписи (одинаковые разделы у разных объектов —
// один цвет; разные — разные, пока их не больше TREE_RAIL_COLORS). Ответ — Map подпись → 0..5
export function railColor_order(captions) {
    const m = new Map()
    for (const c of captions || []) { const k = String(c ?? ''); if (!m.has(k)) m.set(k, m.size % TREE_RAIL_COLORS) }
    return m
}

// Классы строки (фокус, подсветка поддерева): focus — корень фокуса (-1 — нет), hover — раскрытая группа под курсором (-1 — нет)
export function treeLevels_rowClasses(T, i, focus, hover) {
    const out = {}
    for (const c of TLS_CLASSES) out[c] = false
    if (!T || i < 0 || i >= T.n || !T.vis[i]) return out
    if (focus >= 0) { if (i === focus) out['tls-froot'] = true; else if (!treeLevels_inSubtree(T, focus, i)) out['tls-dim'] = true }
    if (hover >= 0 && treeLevels_inSubtree(T, hover, i)) { out['tls-sub'] = true; if (i === hover) out['tls-subh'] = true }
    return out
}

const solid = c => `linear-gradient(${c}, ${c})`
const arc = (c, at) => `radial-gradient(circle at ${at}, transparent 3.5px, ${c} 3.5px, ${c} 4.5px, transparent 5px)`
const pxs = v => (v === 0 ? '0' : `${v}px`)

// Слой в координатах колонки дерева (x — от левого края колонки, w — число или Infinity — до конца) делится на маску отступа [0, pad) и ячейку [pad, …)
function splitLayer(g, pad, cell, mask, whole) {
    const x = g.x, w = g.w
    if (whole) { (x < pad ? mask : cell).push({ img: g.img, pos: `${pxs(x < pad ? x : x - pad)} ${g.y}`, size: `${pxs(w)} ${g.h}` }); return }
    if (x < pad) {
        const mw = w === Infinity ? pad - x : Math.min(w, pad - x)
        if (mw > 0) mask.push({ img: g.img, pos: `${pxs(x)} ${g.y}`, size: `${pxs(mw)} ${g.h}` })
    }
    if (w === Infinity || x + w > pad) {
        const cx = Math.max(0, x - pad)
        const cw = w === Infinity ? (cx ? `calc(100% - ${cx}px)` : '100%') : pxs(x + w - Math.max(x, pad))
        cell.push({ img: g.img, pos: `${pxs(cx)} ${g.y}`, size: `${cw} ${g.h}` })
    }
}

export function layers_css(list) {
    if (!list || !list.length) return null
    return { image: list.map(l => l.img).join(', '), position: list.map(l => l.pos).join(', '), size: list.map(l => l.size).join(', ') }
}

// Слои фона ячейки строки i под режим. kind: 't' — ячейка колонки дерева (с маской отступа слева), 'c' — прочая, 'l' — последняя видимая колонка.
// geo: { indent, gl — левый край глифа свёртки в ячейке, gc — его середина }. ctx: { branch — группа текущей строки (guides), railIdx(root) → 0..5 }.
// Ответ: { cell, mask } — { image, position, size } или null (нечего рисовать)
export function treeLevel_layers(mode, T, i, kind, geo, ctx) {
    const res = { cell: null, mask: null }
    if (!T || i < 0 || i >= T.n || !T.vis[i]) return res
    const ind = geo?.indent || TREE_INDENT, gl = Number.isFinite(geo?.gl) ? geo.gl : 5, gc = Number.isFinite(geo?.gc) ? geo.gc : gl + 4
    const lv = Math.max(0, T.level[i]), pad = lv * ind
    const cell = [], mask = [], tint = [], maskTint = []
    const tree = kind === 't', last = kind === 'l'
    if (mode === 'guides') {
        if (!tree) return res
        const anc = treeLevels_ancestors(T, i), k = anc.length, branch = ctx?.branch ?? -1
        for (let j = 0; j < k; j++) {
            const a = anc[j], X = Math.max(0, T.level[a]) * ind + gc
            const c = a === branch ? 'var(--tls-guide-on)' : 'var(--tls-guide)'
            if (j === k - 1) {
                splitLayer({ img: solid(c), x: X, w: 1, y: '0', h: '50%' }, pad, cell, mask)
                splitLayer({ img: solid(c), x: X, w: Math.max(1, pad + gl - 1 - X), y: '50%', h: '1px' }, pad, cell, mask)
                if (T.hasNext[i]) splitLayer({ img: solid(c), x: X, w: 1, y: '0', h: '100%' }, pad, cell, mask)
            } else if (T.hasNext[anc[j + 1]]) {
                splitLayer({ img: solid(c), x: X, w: 1, y: '0', h: '100%' }, pad, cell, mask)
            }
        }
    } else if (mode === 'depth') {
        const t = treeLevels_depthTone(T, i)
        if (!t) return res
        const c = `var(--tls-tone-${t})`
        if (tree) splitLayer({ img: solid(c), x: 0, w: Infinity, y: '0', h: '100%' }, pad, tint, maskTint)
        else tint.push({ img: solid(c), pos: '0 0', size: '100% 100%' })
    } else if (mode === 'rail') {
        if (!tree) return res
        const r = T.root[i]
        if (r < 0) return res
        const idx = (ctx?.railIdx ? ctx.railIdx(r) : 0) % TREE_RAIL_COLORS
        const c = `var(--tls-rail-${idx})`, cs = `color-mix(in srgb, var(--tls-rail-${idx}) 55%, transparent)`
        const chain = treeLevels_ancestors(T, i).concat([i]).filter(a => a >= r && T.styled[a] && T.root[a] === r)
        for (const a of chain) {
            if (a === r) { splitLayer({ img: solid(c), x: 0, w: 4, y: '0', h: '100%' }, pad, cell, mask); continue }
            const d = Math.max(0, T.level[a]) - Math.max(0, T.level[r])
            const X = Math.max(5, Math.max(0, T.level[a]) * ind + gl - 4)
            splitLayer({ img: solid(cs), x: X, w: d === 1 ? 3 : 2, y: '0', h: '100%' }, pad, cell, mask)
        }
    } else if (mode === 'card') {
        const r = T.root[i]
        if (r < 0) return res
        const top = i === r, bot = i === T.lastDesc[r], R = TREE_CARD_R
        const cb = 'var(--tls-card-b)', csh = 'var(--tls-card-sh)'
        if (tree) {
            const Xl = Math.max(0, T.level[r]) * ind + 1
            const vh = (top ? R : 0) + (bot ? R : 0)
            splitLayer({ img: solid(cb), x: Xl, w: 1, y: pxs(top ? R : 0), h: vh ? `calc(100% - ${vh}px)` : '100%' }, pad, cell, mask, true)
            if (top) {
                splitLayer({ img: arc(cb, '100% 100%'), x: Xl, w: R, y: '0', h: `${R}px` }, pad, cell, mask, true)
                splitLayer({ img: solid(cb), x: Xl + R, w: Infinity, y: '0', h: '1px' }, pad, cell, mask)
                splitLayer({ img: solid('var(--tls-tone-2)'), x: Xl, w: Infinity, y: '0', h: '100%' }, pad, tint, maskTint)
            }
            if (bot) {
                splitLayer({ img: arc(csh, '100% 0'), x: Xl, w: R, y: '100%', h: `${R}px` }, pad, cell, mask, true)
                splitLayer({ img: solid(csh), x: Xl + R, w: Infinity, y: '100%', h: '1px' }, pad, cell, mask)
            }
        } else {
            const lw = last ? `calc(100% - ${R}px)` : '100%'
            if (top) { cell.push({ img: solid(cb), pos: '0 0', size: `${lw} 1px` }); tint.push({ img: solid('var(--tls-tone-2)'), pos: '0 0', size: '100% 100%' }) }
            if (bot) cell.push({ img: solid(csh), pos: '0 100%', size: `${lw} 1px` })
            if (last) {
                const vh = (top ? R : 0) + (bot ? R : 0)
                cell.push({ img: solid(cb), pos: `100% ${pxs(top ? R : 0)}`, size: `1px ${vh ? `calc(100% - ${vh}px)` : '100%'}` })
                if (top) cell.push({ img: arc(cb, '0 100%'), pos: '100% 0', size: `${R}px ${R}px` })
                if (bot) cell.push({ img: arc(csh, '0 0'), pos: '100% 100%', size: `${R}px ${R}px` })
            }
        }
    } else return res
    res.cell = layers_css(cell.concat(tint))
    res.mask = layers_css(mask.concat(maskTint))
    return res
}
